/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/ChallengeAuthorities/AchieveScoreDailyPyramidAuthority',[
    'SolitaireShared/PyramidLogic/PyramidAuthority',
    'SolitaireShared/PyramidLogic/IDailyPyramidAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/IAchieveScoreDailyAuthority',
    'SolitaireShared/CardLogic/ChallengeConstants'
], function (PyramidAuthority, IDailyPyramidAuthority, IDailyAuthority, IAchieveScoreDailyAuthority, ChallengeConstants) {
    "use strict";

    var AchieveScoreDailyPyramidAuthority = function (param) {
        this.initAchieveScoreDailyPyramidAuthority(param);
    };

    AchieveScoreDailyPyramidAuthority.constructor = AchieveScoreDailyPyramidAuthority;
    AchieveScoreDailyPyramidAuthority.prototype = Object.create(IDailyPyramidAuthority.prototype);
    IAchieveScoreDailyAuthority.call(AchieveScoreDailyPyramidAuthority.prototype);

    AchieveScoreDailyPyramidAuthority.prototype.initAchieveScoreDailyPyramidAuthority = function (param) {
        IDailyPyramidAuthority.call(this);

        if (param != null && param[ChallengeConstants.KeyScoreRequired])
            this.ScoreRequired = parseInt(param[ChallengeConstants.KeyScoreRequired]);
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.AchieveScore;
    };

    AchieveScoreDailyPyramidAuthority.prototype.IsGameWon = function () {
        if (this.CardSupply.WaitingForAnimation)
        {
            // We don't win unless the card animation is finished.
            return false;
        }

        if(this.CardSupply.IsWaitingForAds)
        {
            return false;
        }
//#if !GAMESTATETOOL
            if(!this.CardSupply.IsGamePageLoaded)
            {
                return false;
            }
//#endif
        if (this.CheckWin() && this.CardSupply.Score < this.ScoreRequired)
        {
            this.Deal();
        }
        return this.CardSupply.Score >= this.ScoreRequired;
    };

    return AchieveScoreDailyPyramidAuthority;
});
